import React, { useCallback, useRef, useState } from "react";
import { Tooltip } from "reactstrap";
import * as Scrivito from "scrivito";
import { SORTING_CRITERIA } from "variables";
import { useAppBaseContext } from "providers";
import { VirtualizedModalTable } from "components/VirtualizedTable/VirtualizedModalTable";
import { useTranslate } from "hooks";
import { ProductListTableRow } from "./ProductListTableRow";
import { SortButton } from "../../SortButton/SortButton";

export const ProductListTable = Scrivito.connect(
  ({
    products = [],
    isOrderDescending,
    setIsOrderDescending,
    skeletonCount,
    fetchingProductList,
    tableRef,
    commissionFetching,
    isLastPage,
    commissioningProduct,
    setSortCriteria,
    sortCriteria,
    setCurrentPageNo,
    isModalView,
    priceGroupDescription,
  }) => {
    const translate = useTranslate();
    const priceColRef = useRef(null);
    const { isSameProj } = useAppBaseContext();
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggleTooltip = useCallback(
      () => setTooltipOpen(!tooltipOpen),
      [tooltipOpen],
    );

    const unitPriceLabel = !isSameProj
      ? translate("UNIT_PRICE")
      : translate("UNIT_PRICE_SAME");

    const totalPriceLabel = !isSameProj
      ? translate("TOTAL_PRICE")
      : translate("TOTAL_PRICE_SAME");

    const columns = [
      {
        label: (
          <div className="d-flex justify-content-between">
            {translate("NAME")}
            <SortButton
              sortCriteria={SORTING_CRITERIA.NAME}
              currentSort={sortCriteria}
              setSortCriteria={setSortCriteria}
              isOrderDescending={isOrderDescending}
              setIsOrderDescending={setIsOrderDescending}
              setCurrentPageNo={setCurrentPageNo}
            />
          </div>
        ),
        width: "20%",
      },
      {
        label: (
          <div className="d-flex justify-content-between">
            {translate("PRESENTATION_ORDER_CODE")}
            <SortButton
              sortCriteria={SORTING_CRITERIA.PRESENTATION}
              currentSort={sortCriteria}
              setSortCriteria={setSortCriteria}
              isOrderDescending={isOrderDescending}
              setIsOrderDescending={setIsOrderDescending}
              setCurrentPageNo={setCurrentPageNo}
            />
          </div>
        ),
        width: "25%",
      },
      { label: translate("QUANTITY"), width: "10%" },
      {
        label: (
          <div className="d-flex justify-content-between">
            {unitPriceLabel}
            <SortButton
              sortCriteria={SORTING_CRITERIA.UNIT_PRICE}
              currentSort={sortCriteria}
              setSortCriteria={setSortCriteria}
              isOrderDescending={isOrderDescending}
              setIsOrderDescending={setIsOrderDescending}
              setCurrentPageNo={setCurrentPageNo}
            />
          </div>
        ),
        width: "15%",
      },
      {
        label: (
          <div className="d-flex justify-content-between">
            {totalPriceLabel}
            <SortButton
              sortCriteria={SORTING_CRITERIA.TOTAL_PRICE}
              currentSort={sortCriteria}
              setSortCriteria={setSortCriteria}
              isOrderDescending={isOrderDescending}
              setIsOrderDescending={setIsOrderDescending}
              setCurrentPageNo={setCurrentPageNo}
            />
          </div>
        ),
        width: "15%",
      },

      {
        label: (
          <>
            <div className="d-flex justify-content-between">
              <span ref={priceColRef}>{translate("PRICE_GROUP")}</span>
              <SortButton
                sortCriteria={SORTING_CRITERIA.PRICE_GROUP}
                currentSort={sortCriteria}
                setSortCriteria={setSortCriteria}
                isOrderDescending={isOrderDescending}
                setIsOrderDescending={setIsOrderDescending}
                setCurrentPageNo={setCurrentPageNo}
              />
            </div>

            <Tooltip
              target={() => priceColRef.current}
              placement="top"
              isOpen={tooltipOpen}
              toggle={toggleTooltip}
            >
              <span className="fw-normal text-gray-400">
                {priceGroupDescription}
              </span>
            </Tooltip>
          </>
        ),
        width: "15%",
      },
    ];

    const renderRow = (product) => (
      <ProductListTableRow
        key={product.key}
        product={product}
        fetchingProductList={fetchingProductList}
      />
    );

    return (
      <VirtualizedModalTable
        columns={columns}
        products={products}
        renderRow={renderRow}
        fetchingProductList={fetchingProductList}
        skeletonCount={skeletonCount}
        isLastPage={isLastPage}
        commissioningProduct={commissioningProduct}
        commissionFetching={commissionFetching}
        tableRef={tableRef}
        isModalView={isModalView}
      />
    );
  },
);
